/**
 * Empty-state illustration shown on the co-borrower step before a
 * co-borrower has been added. Purely presentational.
 */
export const CoBorrowerEmptyStateGraphic = () => (
  <svg
    width="194"
    height="100"
    viewBox="0 0 194 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_1_10298)">
      <g clipPath="url(#clip0_1_10298)">
        <path
          d="M0 12C0 5.37258 5.37258 0 12 0H182C188.627 0 194 5.37258 194 12V88C194 94.6274 188.627 100 182 100H12C5.37258 100 0 94.6274 0 88V12Z"
          fill="#F3F5F8"
        />
        <g opacity="0.1" clipPath="url(#clip1_1_10298)">
          <path
            opacity="0.8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M252.297 -79.6016L246.432 -74.5435C240.567 -69.4854 228.387 -58.9802 227.546 -36.2381C226.254 -13.1069 235.914 21.8102 226.066 35.021C216.281 47.3918 187.44 37.6672 172.926 45.4669C159.252 53.3284 159.904 78.7142 148.175 88.8304C135.994 99.3356 111.43 94.5712 93.0895 97.0216C74.2974 99.8611 62.5677 109.977 65.5538 138.069C68.9911 165.771 87.1441 211.448 88.248 236.445C89.3519 261.442 72.8931 266.987 56.8856 272.143C40.4269 277.688 24.4193 282.844 3.68276 283.429C-16.9916 283.174 -41.5549 278.409 -47.1245 296.58C-52.243 314.362 -38.7566 354.628 -50.4864 364.745C-62.6672 375.25 -100.064 355.605 -116.461 360.31C-132.919 365.855 -127.149 396.263 -133.107 413.983C-138.226 431.765 -154.684 437.31 -162.883 439.662L-170.692 442.466L-45.1781 587.999L-39.3132 582.941C-33.4484 577.883 -21.2675 567.378 -9.53783 557.262C2.64303 546.757 14.3727 536.64 26.5536 526.135C38.2833 516.019 50.013 505.903 62.1938 495.398C73.9236 485.281 86.1044 474.776 97.8341 464.66C110.015 454.155 121.745 444.039 133.474 433.922C145.655 423.417 157.385 413.301 169.566 402.796C181.296 392.68 193.476 382.174 205.206 372.058C216.936 361.942 229.117 351.437 240.846 341.321C253.027 330.815 264.757 320.699 276.938 310.194C288.667 300.078 300.397 289.962 312.578 279.456C324.308 269.34 336.489 258.835 348.218 248.719C360.399 238.214 372.129 228.098 383.859 217.981C396.039 207.476 407.769 197.36 419.95 186.855C431.68 176.739 443.86 166.233 449.725 161.175L455.59 156.117L252.297 -79.6016Z"
            fill="#1453F5"
          />
          <path
            opacity="0.32"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M219.582 -112.316L213.717 -107.258C207.852 -102.2 195.671 -91.695 194.831 -68.9529C193.539 -45.8217 203.199 -10.9047 193.351 2.30614C183.566 14.6769 154.725 4.95235 140.211 12.752C126.536 20.6136 127.189 45.9994 115.459 56.1155C103.279 66.6208 78.7153 61.8564 60.3744 64.3068C41.5823 67.1463 29.8526 77.2624 32.8387 105.354C36.276 133.056 54.429 178.734 55.5329 203.73C56.6368 228.727 40.1781 234.272 24.1705 239.428C7.71179 244.973 -8.29577 250.129 -29.0323 250.714C-49.7067 250.459 -74.27 245.694 -79.8396 263.865C-84.958 281.647 -71.4717 321.914 -83.2015 332.03C-95.3823 342.535 -132.779 322.89 -149.176 327.595C-165.634 333.14 -159.864 363.548 -165.822 381.268C-170.941 399.05 -187.399 404.595 -195.598 406.947L-203.407 409.751L-77.8932 555.284L-72.0283 550.226C-66.1634 545.168 -53.9826 534.663 -42.2529 524.547C-30.0721 514.042 -18.3423 503.926 -6.16148 493.42C5.56823 483.304 17.2979 473.188 29.4788 462.683C41.2085 452.567 53.3893 442.061 65.119 431.945C77.2999 421.44 89.0296 411.324 100.759 401.208C112.94 390.702 124.67 380.586 136.851 370.081C148.58 359.965 160.761 349.46 172.491 339.343C184.221 329.227 196.402 318.722 208.131 308.606C220.312 298.101 232.042 287.984 244.223 277.479C255.952 267.363 267.682 257.247 279.863 246.742C291.593 236.625 303.773 226.12 315.503 216.004C327.684 205.499 339.414 195.383 351.143 185.267C363.324 174.761 375.054 164.645 387.235 154.14C398.965 144.024 411.145 133.518 417.01 128.46L422.875 123.402L219.582 -112.316Z"
            fill="#1453F5"
          />
          <path
            opacity="0.32"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M185.768 -131L179.903 -125.942C174.039 -120.884 161.858 -110.379 161.017 -87.6365C159.725 -64.5053 169.385 -29.5883 159.538 -16.3775C149.752 -4.00666 120.911 -13.7312 106.397 -5.93157C92.7227 1.92996 93.3755 27.3158 81.6458 37.4319C69.4649 47.9372 44.9016 43.1728 26.5607 45.6232C7.76859 48.4627 -3.96111 58.5788 -0.974994 86.6702C2.46225 114.372 20.6153 160.05 21.7192 185.047C22.823 210.043 6.36434 215.588 -9.64323 220.744C-26.1019 226.289 -42.1095 231.445 -62.8461 232.03C-83.5204 231.775 -108.084 227.011 -113.653 245.182C-118.772 262.964 -105.285 303.23 -117.015 313.346C-129.196 323.851 -166.593 304.206 -182.989 308.911C-199.448 314.457 -193.677 344.864 -199.636 362.584C-204.754 380.366 -221.213 385.911 -229.411 388.264L-237.221 391.067L-111.707 536.601L-105.842 531.543C-99.9772 526.485 -87.7963 515.979 -76.0666 505.863C-63.8858 495.358 -52.1561 485.242 -39.9752 474.737C-28.2455 464.621 -16.5158 454.504 -4.33497 443.999C7.39476 433.883 19.5756 423.378 31.3053 413.262C43.4862 402.756 55.2159 392.64 66.9456 382.524C79.1264 372.019 90.8561 361.903 103.037 351.397C114.767 341.281 126.948 330.776 138.677 320.66C150.407 310.544 162.588 300.038 174.318 289.922C186.498 279.417 198.228 269.301 210.409 258.796C222.139 248.679 233.868 238.563 246.049 228.058C257.779 217.942 269.96 207.437 281.689 197.32C293.87 186.815 305.6 176.699 317.33 166.583C329.511 156.078 341.24 145.962 353.421 135.456C365.151 125.34 377.332 114.835 383.197 109.777L389.061 104.719L185.768 -131Z"
            fill="#1453F5"
          />
        </g>
        <g filter="url(#filter1_dd_1_10298)">
          <path
            d="M99.3994 51.3343C100.919 51.3322 102.265 51.3304 103.532 51.7802C103.794 51.8729 104.05 51.9795 104.3 52.0997C105.513 52.6828 106.463 53.6404 107.536 54.7221L120.29 67.5425C121.537 68.7914 122.643 69.8999 123.24 71.3499C123.838 72.7999 123.835 74.3699 123.833 76.1389L123.832 85.4036C123.832 90.1556 123.832 133.986 123.429 136.998C123.011 140.126 122.116 142.759 120.035 144.851C117.955 146.942 115.335 147.842 112.224 148.262C109.227 148.667 105.416 148.667 100.689 148.667C95.9614 148.667 83.7717 148.667 80.7748 148.262C77.6634 147.842 75.0436 146.942 72.963 144.851C70.8823 142.759 69.9874 140.126 69.5691 136.998C69.1661 133.986 69.1662 90.1556 69.1663 85.4037V73.2076C69.1662 69.1178 69.1662 65.8204 69.4709 63.1968C69.7862 60.4823 70.4574 58.1564 72.0378 56.1861C72.6179 55.4629 73.2732 54.8041 73.9927 54.221C75.9528 52.6324 78.2667 51.9577 80.9672 51.6408C83.5772 51.3344 95.3308 51.3342 99.3994 51.3343Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.0488 68.3245C89.3818 68.3245 89.6543 68.5969 89.6543 68.9299V70.4434H91.1678C91.5008 70.4434 91.7732 70.7159 91.7732 71.0488C91.7732 71.3818 91.5008 71.6543 91.1678 71.6543H89.6543V73.1678C89.6543 73.5008 89.3818 73.7732 89.0488 73.7732C88.7159 73.7732 88.4434 73.5008 88.4434 73.1678V71.6543H86.9299C86.5969 71.6543 86.3245 71.3818 86.3245 71.0488C86.3245 70.7159 86.5969 70.4434 86.9299 70.4434H88.4434V68.9299C88.4434 68.5969 88.7159 68.3245 89.0488 68.3245Z"
            fill="#1453F5"
          />
          <path
            d="M86.755 69.5475L85.7197 69.2327V68.0582C86.7973 67.2167 87.5359 66.2056 87.5359 64.0382C87.5359 62.6337 87.2817 61.3623 85.7439 61.3623C85.7439 61.3623 85.2051 60.7568 83.8974 60.7568C82.0569 60.7568 80.8764 61.8648 80.8764 64.0382C80.8764 66.2117 81.615 67.2167 82.6926 68.0582V69.2327L80.4405 69.9107C79.5989 70.165 78.9754 70.8431 78.7695 71.6604C78.6848 71.9873 78.9693 72.2598 79.3023 72.2598H86.0163C85.647 71.9813 85.4109 71.5454 85.4109 71.0489C85.4109 70.274 85.9982 69.6323 86.7489 69.5475H86.755Z"
            fill="#AEB3BB"
          />
          <path
            d="M103.532 51.7858C103.794 51.8785 104.05 51.9851 104.3 52.1053C105.513 52.6884 106.463 53.6459 107.536 54.7276L120.29 67.5481L120.29 67.5481C121.537 68.797 122.643 69.9054 123.24 71.3554C123.504 71.9947 123.65 72.6573 123.732 73.35H118.45C114.803 73.35 113.074 73.3479 110.762 73.0371C108.361 72.7144 106.34 72.024 104.735 70.4189C103.13 68.8138 102.44 66.7928 102.117 64.3925C101.807 62.0853 101.807 60.3581 101.807 56.7266V56.7265V51.416C102.403 51.4775 102.975 51.588 103.532 51.7858Z"
            fill="#D2D5DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M104 89.5C104 88.6716 103.116 88 102.026 88H80.9737C79.8836 88 79 88.6716 79 89.5C79 90.3284 79.8836 91 80.9737 91H102.026C103.116 91 104 90.3284 104 89.5Z"
            fill="#D2D5DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M93 80.5C93 79.6716 92.1453 79 91.0909 79H80.9091C79.8547 79 79 79.6716 79 80.5C79 81.3284 79.8547 82 80.9091 82H91.0909C92.1453 82 93 81.3284 93 80.5Z"
            fill="#D2D5DB"
          />
        </g>
        <g opacity="0.8" filter="url(#filter2_dd_1_10298)">
          <g clipPath="url(#clip2_1_10298)">
            <rect x="31" y="44" width="24" height="24" rx="12" fill="#6F41E6" />
            <path
              d="M40.7543 60V52.65H43.3478C43.8518 52.65 44.2963 52.7515 44.6813 52.9545C45.0663 53.1575 45.3673 53.441 45.5843 53.805C45.8013 54.162 45.9098 54.5785 45.9098 55.0545C45.9098 55.5165 45.8083 55.9295 45.6053 56.2935C45.4023 56.6575 45.1188 56.9445 44.7548 57.1545C44.3978 57.3575 43.9813 57.459 43.5053 57.459H41.9723V60H40.7543ZM41.9723 56.3355H43.4843C43.8343 56.3355 44.1213 56.2165 44.3453 55.9785C44.5693 55.7405 44.6813 55.4325 44.6813 55.0545C44.6813 54.6695 44.5553 54.358 44.3033 54.12C44.0513 53.882 43.7258 53.763 43.3268 53.763H41.9723V56.3355Z"
              fill="white"
            />
          </g>
          <rect
            x="30.25"
            y="43.25"
            width="25.5"
            height="25.5"
            rx="12.75"
            stroke="white"
            strokeWidth="1.5"
          />
        </g>
        <g opacity="0.8" filter="url(#filter3_dd_1_10298)">
          <g clipPath="url(#clip3_1_10298)">
            <rect
              x="138"
              y="54"
              width="24"
              height="24"
              rx="12"
              fill="#099E71"
            />
            <path
              d="M150.082 70.126C149.697 70.126 149.344 70.0805 149.022 69.9895C148.707 69.8985 148.427 69.7725 148.182 69.6115C147.944 69.4505 147.744 69.272 147.583 69.076C147.429 68.873 147.321 68.663 147.258 68.446L148.455 68.0785C148.546 68.3375 148.724 68.565 148.99 68.761C149.256 68.957 149.585 69.0585 149.977 69.0655C150.432 69.0655 150.793 68.971 151.059 68.782C151.325 68.593 151.458 68.3445 151.458 68.0365C151.458 67.7565 151.346 67.529 151.122 67.354C150.898 67.172 150.597 67.032 150.219 66.934L149.316 66.703C148.973 66.612 148.661 66.479 148.381 66.304C148.108 66.129 147.891 65.9085 147.73 65.6425C147.576 65.3765 147.499 65.0615 147.499 64.6975C147.499 64.0115 147.723 63.4795 148.171 63.1015C148.619 62.7165 149.26 62.524 150.093 62.524C150.562 62.524 150.971 62.5975 151.321 62.7445C151.678 62.8845 151.972 63.0805 152.203 63.3325C152.434 63.5775 152.606 63.8575 152.718 64.1725L151.542 64.5505C151.437 64.2705 151.255 64.0395 150.996 63.8575C150.737 63.6755 150.415 63.5845 150.03 63.5845C149.631 63.5845 149.316 63.679 149.085 63.868C148.861 64.057 148.749 64.3195 148.749 64.6555C148.749 64.9285 148.836 65.142 149.011 65.296C149.193 65.443 149.438 65.555 149.746 65.632L150.649 65.8525C151.307 66.0135 151.818 66.29 152.182 66.682C152.546 67.074 152.728 67.508 152.728 67.984C152.728 68.404 152.627 68.775 152.424 69.097C152.221 69.419 151.92 69.671 151.521 69.853C151.129 70.035 150.649 70.126 150.082 70.126Z"
              fill="white"
            />
          </g>
          <rect
            x="137.25"
            y="53.25"
            width="25.5"
            height="25.5"
            rx="12.75"
            stroke="white"
            strokeWidth="1.5"
          />
        </g>
        <g opacity="0.8" filter="url(#filter4_dd_1_10298)">
          <g clipPath="url(#clip4_1_10298)">
            <rect x="85" y="14" width="24" height="24" rx="12" fill="#4075FF" />
            <path
              d="M96.4692 30.1365C96.1472 30.1365 95.8602 30.0875 95.6082 29.9895C95.3632 29.8915 95.1497 29.762 94.9677 29.601C94.7857 29.44 94.6352 29.265 94.5162 29.076C94.4042 28.887 94.3202 28.7015 94.2642 28.5195L95.2617 28.089C95.3877 28.376 95.5487 28.6035 95.7447 28.7715C95.9477 28.9395 96.1927 29.0235 96.4797 29.0235C96.7107 29.0235 96.9277 28.971 97.1307 28.866C97.3407 28.754 97.5122 28.579 97.6452 28.341C97.7782 28.103 97.8447 27.788 97.8447 27.396V22.65H99.0627V27.7845C99.0627 28.1625 98.9927 28.4985 98.8527 28.7925C98.7197 29.0795 98.5342 29.3245 98.2962 29.5275C98.0582 29.7305 97.7817 29.8845 97.4667 29.9895C97.1517 30.0875 96.8192 30.1365 96.4692 30.1365Z"
              fill="white"
            />
          </g>
          <rect
            x="84.25"
            y="13.25"
            width="25.5"
            height="25.5"
            rx="12.75"
            stroke="white"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <path
        d="M12 0.5H182C188.351 0.5 193.5 5.64873 193.5 12V88C193.5 94.3513 188.351 99.5 182 99.5H12C5.64873 99.5 0.5 94.3513 0.5 88V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
        stroke="#E4E7EC"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1_10298"
        x="0"
        y="0"
        width="194"
        height="100"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1_10298"
        />
      </filter>
      <filter
        id="filter1_dd_1_10298"
        x="23.9333"
        y="19.8"
        width="145.133"
        height="188.133"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="10.4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1_10298"
        />
        <feOffset dy="13.8667" />
        <feGaussianBlur stdDeviation="27.7333" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_10298"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.73333" />
        <feGaussianBlur stdDeviation="3.46667" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_10298"
          result="effect2_dropShadow_1_10298"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1_10298"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_1_10298"
        x="-15.5667"
        y="11.3"
        width="117.133"
        height="117.133"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="10.4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1_10298"
        />
        <feOffset dy="13.8667" />
        <feGaussianBlur stdDeviation="27.7333" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_10298"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.73333" />
        <feGaussianBlur stdDeviation="3.46667" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_10298"
          result="effect2_dropShadow_1_10298"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1_10298"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_1_10298"
        x="91.4333"
        y="21.3"
        width="117.133"
        height="117.133"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="10.4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1_10298"
        />
        <feOffset dy="13.8667" />
        <feGaussianBlur stdDeviation="27.7333" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_10298"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.73333" />
        <feGaussianBlur stdDeviation="3.46667" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_10298"
          result="effect2_dropShadow_1_10298"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1_10298"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_dd_1_10298"
        x="38.4333"
        y="-18.7"
        width="117.133"
        height="117.133"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="10.4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1_10298"
        />
        <feOffset dy="13.8667" />
        <feGaussianBlur stdDeviation="27.7333" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_10298"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.73333" />
        <feGaussianBlur stdDeviation="3.46667" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_10298"
          result="effect2_dropShadow_1_10298"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1_10298"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1_10298">
        <path
          d="M0 12C0 5.37258 5.37258 0 12 0H182C188.627 0 194 5.37258 194 12V88C194 94.6274 188.627 100 182 100H12C5.37258 100 0 94.6274 0 88V12Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_1_10298">
        <rect
          width="208"
          height="100"
          fill="white"
          transform="translate(-14)"
        />
      </clipPath>
      <clipPath id="clip2_1_10298">
        <rect x="31" y="44" width="24" height="24" rx="12" fill="white" />
      </clipPath>
      <clipPath id="clip3_1_10298">
        <rect x="138" y="54" width="24" height="24" rx="12" fill="white" />
      </clipPath>
      <clipPath id="clip4_1_10298">
        <rect x="85" y="14" width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
